import React from 'react';
import { HiMiniChevronLeft, HiMiniComputerDesktop } from 'react-icons/hi2';
import InboxThreadList from '../../components/InboxThreadList';
import InboxChatArea from '../../components/InboxChatArea';
import InboxSelector from '../../components/InboxSelector';
import { InboxChannelSelector } from '../../components/InboxChannelSelector';
import { useInbox } from '../../contexts/inbox';
import { getThreadDisplayInfo } from '../../utils/threadDisplay';

/**
 * Single-pane Inbox sized for phones. It covers the desktop shell entirely and
 * derives the visible pane from the inbox context: an open conversation or
 * composer shows the chat pane, anything else the thread list.
 */
const MobileInbox = ({ onExitMobileView }) => {
  const {
    selectedChannel,
    setSelectedChannel,
    selectedFishThread,
    setSelectedFishThread,
    isNewMessageOpen,
    setIsNewMessageOpen,
  } = useInbox();

  const isChatPane = isNewMessageOpen || Boolean(selectedFishThread);

  const handleBack = () => {
    setSelectedFishThread(null);
    setIsNewMessageOpen(false);
  };

  let title = 'Inbox';
  if (selectedFishThread) {
    title =
      getThreadDisplayInfo(selectedFishThread, selectedChannel).name ||
      'Conversation';
  } else if (isNewMessageOpen) {
    title = 'New message';
  }

  const subtitle =
    selectedChannel === 'EMAIL' && !selectedFishThread?.isDraft
      ? selectedFishThread?.subject
      : null;

  return (
    <div className="fixed inset-x-0 top-0 z-40 flex h-dvh flex-col bg-white">
      <header className="flex shrink-0 items-center gap-1 border-b border-gray-200 px-2 py-2">
        {isChatPane && (
          <button
            type="button"
            onClick={handleBack}
            aria-label="Back to conversations"
            className="rounded p-2 hover:bg-gray-100"
          >
            <HiMiniChevronLeft className="h-6 w-6 text-gray-600" />
          </button>
        )}

        <div className="min-w-0 flex-1 px-1">
          <h1 className="truncate text-lg font-semibold">{title}</h1>
          {subtitle && (
            <p className="truncate text-sm text-gray-500">{subtitle}</p>
          )}
        </div>

        <button
          type="button"
          onClick={onExitMobileView}
          aria-label="Exit mobile view"
          className="rounded p-2 hover:bg-gray-100"
        >
          <HiMiniComputerDesktop className="h-6 w-6 text-gray-600" />
        </button>
      </header>

      {isChatPane ? (
        <InboxChatArea />
      ) : (
        <>
          <div className="shrink-0 space-y-3 px-4 py-3">
            <InboxChannelSelector
              selectedChannel={selectedChannel}
              onChannelChange={setSelectedChannel}
            />
            <InboxSelector />
          </div>

          <InboxThreadList />
        </>
      )}
    </div>
  );
};

export default MobileInbox;
